// DeviceContext.tsx
import {createContext} from "react";

type DeviceContextType = {
    isMobile: boolean;
};

export default createContext<DeviceContextType | undefined>(undefined);
